import { axiosRef } from '.';

export const overViewMetric = (payload: any) => {
  return axiosRef.get(
    `/metrics/overview?account=${payload.account}&start_date=${
      payload.startDate
    }&end_date=${payload.endDate}&accounts=${JSON.stringify(
      payload.accounts
    )}&query_type=${payload.query_type}`
  );
};

export const shipmentPerYearMetric = (payload: any) => {
  return axiosRef.get(
    `/metrics/shipments_per_year?account=${payload.account}&start_date=${
      payload.startDate
    }&end_date=${payload.endDate}&accounts=${JSON.stringify(
      payload.accounts
    )}&years=${JSON.stringify(payload.years)}&query_type=${payload.query_type}`
  );
};

export const averagesMetric = (payload: any) => {
  return axiosRef.get(
    `/metrics/averages?account=${payload.account}&start_date=${
      payload.startDate
    }&end_date=${payload.endDate}&accounts=${JSON.stringify(
      payload.accounts
    )}&query_type=${payload.query_type}`
  );
};

export const routesMetric = (payload: any) => {
  return axiosRef.get(
    `/metrics/routes?account=${payload.account}&start_date=${
      payload.startDate
    }&end_date=${payload.endDate}&accounts=${JSON.stringify(
      payload.accounts
    )}&query_type=${payload.query_type}`
  );
};

export const carriersMetric = (payload: any) => {
  return axiosRef.get(
    `/metrics/carriers?account=${payload.account}&start_date=${
      payload.startDate
    }&end_date=${payload.endDate}&accounts=${JSON.stringify(
      payload.accounts
    )}&query_type=${payload.query_type}`
  );
};

export const metricsBreakdown = (year: string) =>
  axiosRef.get(`/metrics/breakdown?year=${year}`);

export const metricsAccountStats = (
  year: string,
  system: string,
  account: string
) =>
  axiosRef.get(
    `/metrics/accounts?year=${year}&system=${system}&account=${account}`
  );

// export const fetchPromoCodesList = () => axiosRef.get(`promo_code/list`);
export const fetchPromoCodesList = (payload?: any) => {
  let url = `/promo_code/list?`;

  if (payload && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.page && payload.page !== '') {
    url = url + `page=${payload.page}&`;
  }
  if (payload && payload.pageSize && payload.pageSize !== '') {
    url = url + `page_size=${payload.pageSize}&`;
  }
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  return axiosRef.get(url);
};

export const deActivatePromoCode = (id: any) =>
  axiosRef.delete(`promo_code/list/${id}`);

export const addFlatPromoCode = (payload: any) =>
  axiosRef.post(`promo_code/list`, payload);

export const editFlatPromoCode = (payload: any) =>
  axiosRef.put(`promo_code/list/${payload?.id}`, payload);

export const addBulkPromoCode = (payload: any) =>
  axiosRef.post(`promo_code/bulk`, payload);

export const fetchExchangeRatesList = (payload?: any) => {
  let url = `/exchange_rates?`;
  if (payload && payload?.pageSize) {
    url =
      url +
      `page_size=${payload.pageSize}&page=${payload.page}&is_pagination=true&`;
  }
  if (payload && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  return axiosRef.get(url);
};

export const editExchangeRates = (payload: any) =>
  axiosRef.put(`exchange_rates/${payload.id}`, payload);

export const fetchMarkupList = (payload?: any) => {
  let url = `/markups?`;
  if (payload && payload?.pageSize) {
    url = url + `page_size=${payload.pageSize}&page=${payload.page}&`;
  }
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.is_template !== undefined) {
    url = url + `is_template=${payload.is_template}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  return axiosRef.get(url);
};

export const addMarkupService = (payload: any) =>
  axiosRef.post(`markups`, payload);

export const editMarkupService = (payload: any) =>
  axiosRef.put(`markups/${payload.id}`, payload);

export const deleteMarkupService = (id: any) =>
  axiosRef.delete(`markups/${id}`);

export const fetchSubAccountsList = (payload?: any) => {
  let url = `/sub_accounts?`;
  if (payload && payload?.pageSize) {
    url = url + `page_size=${payload.pageSize}&page=${payload.page}&`;
  }
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  return axiosRef.get(url);
};

export const fetchWebhookList = (payload?: any) => {
  let url = `/webhooks?`;
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.account) {
    url = url + `account=${payload.account}&`;
  }
  if (payload && payload.event) {
    url = url + `event=${payload.event}&`;
  }
  if (payload && payload.data_format) {
    url = url + `data_format=${payload.data_format}&`;
  }
  return axiosRef.get(url);
};

export const deleteWebhookService = (id: any) =>
  axiosRef.delete(`/webhooks/${id}`);

export const updateWebhookService = (payload: any) =>
  axiosRef.put(`/webhooks/${payload.id}`, payload);

export const addWebhookService = (payload: any) =>
  axiosRef.post(`/webhooks`, payload);
